export enum ErrorLoggingLevel {
  Log = "log",
  Info = "info",
  Error = "error",
  Warn = "warn",
  Debug = "debug",
}
